import { TbaFinalRange as Component } from './component';
import Connector from './connector';
import { TbaFinalRangeProps } from './TbaFinalRange.proptype';

export const TbaFinalRange = ({ selectedTba }: TbaFinalRangeProps) => {
  return <Connector component={Component} selectedTba={selectedTba} />;
};
